/* shah */
import React from 'react'

const LightModeIcon = () => {
    return (
        <svg id="SmallBoxSVG-lightMode" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M1677 4910 c-318 -132 -577 -309 -822 -561 -382 -393 -607 -860 -681
-1413 -20 -149 -19 -466 1 -621 95 -723 483 -1348 1088 -1751 354 -237 801
-383 1225 -403 454 -20 844 59 1232 250 250 123 428 249 629 444 254 247 436
514 565 832 64 157 62 236 -10 292 -58 46 -92 46 -242 2 -253 -73 -401 -95
-642 -95 -337 0 -619 66 -925 213 -436 211 -787 561 -995 992 -148 309 -214
592 -214 929 0 241 22 389 95 642 44 150 44 184 -2 242 -57 73 -138 75 -302 6z
m-82 -432 c-32 -140 -48 -414 -35 -600 41 -607 277 -1146 690 -1572 369 -380
825 -620 1367 -718 116 -21 156 -23 418 -22 215 1 312 5 375 16 47 9 87 14 89
12 6 -6 -89 -155 -163 -254 -338 -453 -865 -760 -1434 -835 -131 -17 -389 -20
-512 -5 -234 29 -475 98 -682 198 -668 320 -1118 950 -1208 1692 -15 123 -12
381 5 512 83 635 452 1208 993 1544 48 29 90 54 95 54 4 0 5 -10 2 -22z"/>
            </g>
        </svg>
    )
}

export default LightModeIcon